import Axios from 'axios'

// 请求拦截器
Axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
Axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  return error
})

/**
 *  处理网络端错误
 * */
function checkStatus (response) {
  if (response.status === 200 || response.status === 304) {
    return response
  }
  return {status: 'failed'}
}

/***
 * 处理程序段错误
 * @param response
 */
function checkCode (response) {
  return response
}

export default {
  get (url, params) {
    return Axios({
      method: 'get',
      url: url,
      params,
      timeout: 100000,
      headers: {
        'AccessControl-Alow-Origin': '*',
        'Content-Type': 'application/json; charset=utf-8'
      },
      responseType: 'json' // default
    }).then(checkStatus).then(checkCode)
  },
  post (url, data) {
    return Axios({
      method: 'post',
      url,
      data: JSON.stringify(data),
      timeout: 100000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;'
      },
      mode: 'cors',
      responseType: 'json' // default
    }).then(checkStatus).then(checkCode)
  }
}



// WEBPACK FOOTER //
// ./src/wbap-utils/HttpUtil/index.js